import { render, staticRenderFns } from "./Roommates.vue?vue&type=template&id=13acd8b8&"
import script from "./Roommates.vue?vue&type=script&lang=js&"
export * from "./Roommates.vue?vue&type=script&lang=js&"
import style0 from "./Roommates.vue?vue&type=style&index=0&id=13acd8b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports